import styled from "styled-components";
import { ScrollbarStyle } from "../../../styles/components/scrollbar";
import { theme } from "../../../styles/theme";

interface IContainerProps {
  isVisible: boolean;
}

export const Overlay = styled.div<IContainerProps>`
  width: 100vw;
  height: 100vh;

  position: fixed;
  inset: 0;
  z-index: 9999;

  display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  align-items: center;
  justify-content: center;

  background: ${theme.colors.overlay.primary};
`;

export const Container = styled.div`
  max-height: 90vh;
  position: relative;

  overflow: hidden;

  background: ${theme.colors.blue900};
  border-radius: ${theme.border.smallRadius};

  & > main {
    max-height: 80vh;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 25px;

    ${ScrollbarStyle}
  }
`;

export const Header = styled.div`
  width: 100%;
  height: 70px;
  padding: 22px 24px;

  background-color: ${theme.colors.gray100};

  display: flex;
  align-items: center;
  justify-content: space-between;

  & > h1 {
    font-size: ${theme.font.sizes.large};
    font-weight: ${theme.font.normal};
    line-height: ${theme.font.sizes.xlarge};
    color: ${theme.colors.gray200};
  }

  & > button {
    background: none;
  }
`;

export const CloseButton = styled.button`
  background: none;
  position: absolute;
  top: 18px;
  right: 18px;
`;
